import { render } from "./manage_incident_type.html?vue&type=template&id=4d1e2b05&external"
import script from "./manage_incident_type.js?vue&type=script&lang=js&external"
export * from "./manage_incident_type.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__